// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlockUploader-space1-wOBEg {
	margin-bottom: 6px !important;
}

.BlockUploader-space2-QNBNF {
	margin-bottom: 12px !important;
}

.BlockUploader-space3-IqhsC {
	margin-bottom: 18px !important;
}

.BlockUploader-space4-cnMPz {
	margin-bottom: 24px !important;
}

.BlockUploader-space5-R7R__ {
	margin-bottom: 30px !important;
}

.BlockUploader-space6-e5Opa {
	margin-bottom: 36px !important;
}

.BlockUploader-space7-TGkZf {
	margin-bottom: 42px !important;
}

.BlockUploader-space8-qOt2X {
	margin-bottom: 48px !important;
}

.BlockUploader-spaceTop1-IK30d {
	margin-top: 6px !important;
}

.BlockUploader-spaceTop2-XrvWi {
	margin-top: 12px !important;
}

.BlockUploader-spaceTop3-NQyyT {
	margin-top: 18px !important;
}

.BlockUploader-spaceTop4-OJ6tT {
	margin-top: 24px !important;
}

.BlockUploader-spaceTop5-YEa8u {
	margin-top: 30px !important;
}

.BlockUploader-spaceTop6-GPwWB {
	margin-top: 36px !important;
}

.BlockUploader-spaceTop7-ukrjY {
	margin-top: 42px !important;
}

.BlockUploader-spaceTop8-FPXfD {
	margin-top: 48px !important;
}

.BlockUploader-noMargin-pfeT8 {
	margin: 0px !important;
}

.BlockUploader-padding1-fU3ZP {
	padding-bottom: 6px !important;
}

.BlockUploader-padding2-P2jwQ {
	padding-bottom: 12px !important;
}

.BlockUploader-padding3-izHDf {
	padding-bottom: 18px !important;
}

.BlockUploader-padding4-CTYJx {
	padding-bottom: 24px !important;
}

.BlockUploader-padding5-IOsHO {
	padding-bottom: 30px !important;
}

.BlockUploader-padding6-tfC3D {
	padding-bottom: 36px !important;
}

.BlockUploader-padding7-DBisz {
	padding-bottom: 42px !important;
}

.BlockUploader-paddingTop1-grQER {
	padding-top: 6px !important;
}

.BlockUploader-paddingTop2-JZueE {
	padding-top: 12px !important;
}

.BlockUploader-paddingTop3-l6q2r {
	padding-top: 18px !important;
}

.BlockUploader-paddingTop4-SxtNR {
	padding-top: 24px !important;
}

.BlockUploader-paddingTop5-kmJAH {
	padding-top: 30px !important;
}

.BlockUploader-paddingTop6-fG8zv {
	padding-top: 36px !important;
}

.BlockUploader-paddingTop7-a1GZI {
	padding-top: 42px !important;
}

.BlockUploader-noPadding-b6DYR {
	padding: 0px !important;
}

.BlockUploader-spaceMarginBottom0-Z2njp {
	margin-bottom: 0;
}

.BlockUploader-textBold-Ev1xj {
	font-weight: 500 !important;
}

.BlockUploader-textBolder-Vzk0f {
	font-weight: 700 !important;
}

.BlockUploader-textNormal-vXfEF {
	font-weight: normal !important;
}

/*New Design Text Colors */

.BlockUploader-textDarkBlue-ogXQx {
	color: rgb(20, 39, 94) !important;
}

.BlockUploader-textLightBlue-Q_jTS {
	color: rgb(57, 87, 106) !important;
}

.BlockUploader-textLightSandleGreen-d_Wj6 {
	color: rgb(76, 86, 41) !important;
}

.BlockUploader-textLightBrown-y6rbF {
	color: rgb(115, 79, 33) !important;
}

.BlockUploader-textMediumMaroon-YxrB8 {
	color: rgb(87, 37, 51) !important;
}

.BlockUploader-textBrown-_PnYN {
	color: rgb(160, 47, 24) !important;
}

.BlockUploader-textMaroon-kj1g_ {
	color: rgb(155, 49, 67) !important;
}

.BlockUploader-textDarkBrown-MEO6S {
	color: rgb(83, 18, 16) !important;
}

.BlockUploader-textMediumBrown-rFj1H {
	color: rgb(142, 28, 10) !important;
}

.BlockUploader-textSkyBlue-yPmMt {
	color: rgb(37, 117, 141) !important;
}

.BlockUploader-textGray-vWuks {
	color: rgb(77, 65, 51) !important;
}

.BlockUploader-errorMessage-yc6BG {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.BlockUploader-userText-E7FxO {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.BlockUploader-panelHeader-BEkUc {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.BlockUploader-exportSection-zVisU {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.BlockUploader-exportSectionGridSub-j_pgv {
	grid-template-columns: 50% 49% !important;
}

.BlockUploader-exportText-KMR6l {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.BlockUploader-exportLinkImg-rQMA3 {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.BlockUploader-exportImg-yLqVh {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.BlockUploader-linkBtn-hM24f {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.BlockUploader-table-t4Kje {
	display: table;
}

.BlockUploader-tableRow-jhLZe {
	display: table-row;
}

.BlockUploader-tableCell-UYIMc {
	display: table-cell;
	float: none;
}

.BlockUploader-formGroup-hbKPT {
	margin-bottom: 6px;
}

.BlockUploader-marginTop0-duT0D {
	margin-top: 0;
}

.BlockUploader-marginBottom20-a3xs4 {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.BlockUploader-bannerImageBg-vwPeb {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.BlockUploader-bannerDelete-pgY3Q {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.BlockUploader-exportLink-opuCx {
	padding-top: 10px;
	padding-right: 10px;
}

.BlockUploader-seachContent-LsG5h {
	padding-left: 0px;
	margin-bottom: 5px;
}

.BlockUploader-marginBottom9-SQCmO {
	margin-bottom: 9px;
}

.BlockUploader-spaceTop52-r8bgT {
	margin-top: 52px;
}

.BlockUploader-profileViewInner-jQl8k {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.BlockUploader-profileViewMain-hpDfK {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.BlockUploader-profileViewlabel-W8BVA {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.BlockUploader-profileViewMainContent-yxOnZ {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.BlockUploader-reviewsFormStar-1TrX7 {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.BlockUploader-reviewsFormStar-1TrX7 svg {
	cursor: pointer;
}

.BlockUploader-addLanguageText-CPlP0 {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.BlockUploader-exportSection-zVisU {
		grid-template-columns: 100%;
	}

	.BlockUploader-spaceTop52-r8bgT {
		margin-top: 18px;
	}

	.BlockUploader-exportText-KMR6l {
		float: none;
		margin-top: 12px;
	}

	.BlockUploader-exportSectionGridSub-j_pgv {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.BlockUploader-profileViewlabel-W8BVA {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.BlockUploader-profileViewMainContent-yxOnZ {
		width: 100%;
		text-align: center;
	}

	.BlockUploader-panelHeader-BEkUc {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `BlockUploader-space1-wOBEg`,
	"space2": `BlockUploader-space2-QNBNF`,
	"space3": `BlockUploader-space3-IqhsC`,
	"space4": `BlockUploader-space4-cnMPz`,
	"space5": `BlockUploader-space5-R7R__`,
	"space6": `BlockUploader-space6-e5Opa`,
	"space7": `BlockUploader-space7-TGkZf`,
	"space8": `BlockUploader-space8-qOt2X`,
	"spaceTop1": `BlockUploader-spaceTop1-IK30d`,
	"spaceTop2": `BlockUploader-spaceTop2-XrvWi`,
	"spaceTop3": `BlockUploader-spaceTop3-NQyyT`,
	"spaceTop4": `BlockUploader-spaceTop4-OJ6tT`,
	"spaceTop5": `BlockUploader-spaceTop5-YEa8u`,
	"spaceTop6": `BlockUploader-spaceTop6-GPwWB`,
	"spaceTop7": `BlockUploader-spaceTop7-ukrjY`,
	"spaceTop8": `BlockUploader-spaceTop8-FPXfD`,
	"noMargin": `BlockUploader-noMargin-pfeT8`,
	"padding1": `BlockUploader-padding1-fU3ZP`,
	"padding2": `BlockUploader-padding2-P2jwQ`,
	"padding3": `BlockUploader-padding3-izHDf`,
	"padding4": `BlockUploader-padding4-CTYJx`,
	"padding5": `BlockUploader-padding5-IOsHO`,
	"padding6": `BlockUploader-padding6-tfC3D`,
	"padding7": `BlockUploader-padding7-DBisz`,
	"paddingTop1": `BlockUploader-paddingTop1-grQER`,
	"paddingTop2": `BlockUploader-paddingTop2-JZueE`,
	"paddingTop3": `BlockUploader-paddingTop3-l6q2r`,
	"paddingTop4": `BlockUploader-paddingTop4-SxtNR`,
	"paddingTop5": `BlockUploader-paddingTop5-kmJAH`,
	"paddingTop6": `BlockUploader-paddingTop6-fG8zv`,
	"paddingTop7": `BlockUploader-paddingTop7-a1GZI`,
	"noPadding": `BlockUploader-noPadding-b6DYR`,
	"spaceMarginBottom0": `BlockUploader-spaceMarginBottom0-Z2njp`,
	"textBold": `BlockUploader-textBold-Ev1xj`,
	"textBolder": `BlockUploader-textBolder-Vzk0f`,
	"textNormal": `BlockUploader-textNormal-vXfEF`,
	"textDarkBlue": `BlockUploader-textDarkBlue-ogXQx`,
	"textLightBlue": `BlockUploader-textLightBlue-Q_jTS`,
	"textLightSandleGreen": `BlockUploader-textLightSandleGreen-d_Wj6`,
	"textLightBrown": `BlockUploader-textLightBrown-y6rbF`,
	"textMediumMaroon": `BlockUploader-textMediumMaroon-YxrB8`,
	"textBrown": `BlockUploader-textBrown-_PnYN`,
	"textMaroon": `BlockUploader-textMaroon-kj1g_`,
	"textDarkBrown": `BlockUploader-textDarkBrown-MEO6S`,
	"textMediumBrown": `BlockUploader-textMediumBrown-rFj1H`,
	"textSkyBlue": `BlockUploader-textSkyBlue-yPmMt`,
	"textGray": `BlockUploader-textGray-vWuks`,
	"errorMessage": `BlockUploader-errorMessage-yc6BG`,
	"userText": `BlockUploader-userText-E7FxO`,
	"panelHeader": `BlockUploader-panelHeader-BEkUc`,
	"exportSection": `BlockUploader-exportSection-zVisU`,
	"exportSectionGridSub": `BlockUploader-exportSectionGridSub-j_pgv`,
	"exportText": `BlockUploader-exportText-KMR6l`,
	"exportLinkImg": `BlockUploader-exportLinkImg-rQMA3`,
	"exportImg": `BlockUploader-exportImg-yLqVh`,
	"linkBtn": `BlockUploader-linkBtn-hM24f`,
	"table": `BlockUploader-table-t4Kje`,
	"tableRow": `BlockUploader-tableRow-jhLZe`,
	"tableCell": `BlockUploader-tableCell-UYIMc`,
	"formGroup": `BlockUploader-formGroup-hbKPT`,
	"marginTop0": `BlockUploader-marginTop0-duT0D`,
	"marginBottom20": `BlockUploader-marginBottom20-a3xs4`,
	"bannerImageBg": `BlockUploader-bannerImageBg-vwPeb`,
	"bannerDelete": `BlockUploader-bannerDelete-pgY3Q`,
	"exportLink": `BlockUploader-exportLink-opuCx`,
	"seachContent": `BlockUploader-seachContent-LsG5h`,
	"marginBottom9": `BlockUploader-marginBottom9-SQCmO`,
	"spaceTop52": `BlockUploader-spaceTop52-r8bgT`,
	"profileViewInner": `BlockUploader-profileViewInner-jQl8k`,
	"profileViewMain": `BlockUploader-profileViewMain-hpDfK`,
	"profileViewlabel": `BlockUploader-profileViewlabel-W8BVA`,
	"profileViewMainContent": `BlockUploader-profileViewMainContent-yxOnZ`,
	"reviewsFormStar": `BlockUploader-reviewsFormStar-1TrX7`,
	"addLanguageText": `BlockUploader-addLanguageText-CPlP0`
};
module.exports = ___CSS_LOADER_EXPORT___;
